/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { SpaDependencies } from './dependenciesSpaClass.generated.js';
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated.js';
import { absDependencies } from './dependenciesAbs.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated.js';
import { createLup } from '../../factoriesAny.js';
export var lupDependencies = {
  DenseMatrixDependencies,
  SpaDependencies,
  SparseMatrixDependencies,
  absDependencies,
  addScalarDependencies,
  divideScalarDependencies,
  equalScalarDependencies,
  largerDependencies,
  matrixDependencies,
  multiplyScalarDependencies,
  subtractDependencies,
  typedDependencies,
  unaryMinusDependencies,
  createLup
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLup.generated.js
// module id = 549
// module chunks = 2